import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51479cc6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "root" }
const _hoisted_2 = { class: "flex flex-around" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("関連リンク")

import { computed } from 'vue'
import { useInitDataStore } from '@/stores/initDataStore'
import { useNewsHistoryStore } from '@/stores/newsStore'
import { usePopup } from '@/components/common/Popup'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const initDataStore = useInitDataStore()
const newsStore = useNewsHistoryStore()
const { toggle: togglePopup } = usePopup()

const menuIconList = computed(() => {
  return initDataStore.headerMenus.map(m => m.icon)
})

const handleClickHelp = () => {
  window.open('/cdn_images/help.pdf', '_blank')
}

const cautionActive = computed(() => {
  return newsStore.has10DaysNews()
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(togglePopup) && _unref(togglePopup)(...args))),
        class: _normalizeClass([_unref(cautionActive) && 'active', "link-item info"])
      }, "お知らせ", 2),
      (_unref(menuIconList).includes('menu_link'))
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: "link",
            class: "link-item link"
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_unref(menuIconList).includes('menu_help'))
        ? (_openBlock(), _createElementBlock("a", {
            key: 1,
            onClick: handleClickHelp,
            class: "link-item help"
          }, "ヘルプ"))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})